// extracted by mini-css-extract-plugin
export default {"container":"K0egyxGoMYFLGwWEMDDL"};